import { useAdapter } from "../hooks";
import type { CountryIso2Props } from "./types";

export const useCountryIso2 = (props: CountryIso2Props) =>
    useAdapter({
        ...props,
        key: 'iso2'
    });

export default useCountryIso2;
